import { Link, NavLink } from "react-router-dom";
import SideBarLink from "./SideBarLink";
import {
  Categoryssvg,
  Dashboardsvg,
  Userssvg,
  Prayersvg,
  Mediasvg,
  Keyboradsvg,
  Contactsvg,
  Reportsvg,
  Adminsvg,
  ManageBiblePrayerSvg,
} from "../SvgFile/Index";
import { useEffect, useState } from "react";
import Logout from "../Component/Pages/Auth/Logout";

export default function Sidebar() {
  const [open, setOpen] = useState(false);
  const [links, setlinks] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");

  const user = JSON.parse(localStorage.getItem("userData"));

  const handleClose = () => {
    setOpen(false);
  };

  const usertype = localStorage.getItem("usertype");

  useEffect(() => {
    if (usertype === "user") {
    } else {
      let links = [
        { url: "/users", roleName: "Manage Users", icon: <Userssvg /> },
        {
          url: "/sub-category",
          roleName: "Manage Category",
          icon: <Categoryssvg />,
        },
        { url: "/prayer", roleName: "Manage Prayers", icon: <Prayersvg /> },

        {
          url: "/media",
          roleName: "Manage Media Category",
          icon: <Mediasvg />,
        },
        {
          url: "/assistant",
          roleName: "Manage Prayers Assistant",
          icon: <Prayersvg />,
        },
        {
          url: "/keyborad",
          roleName: "Manage Foul Language",
          icon: <Keyboradsvg />,
        },
        {
          url: "/contacts",
          roleName: "Manage Contact Us",
          icon: <Contactsvg />,
        },
        {
          url: "/report",
          roleName: "Prayer Report",
          icon: <Reportsvg />,
        },
        {
          url: "/admincontact",
          roleName: "Admin Contact",
          icon: <Adminsvg />,
        },
        {
          url: "/adminbible",
          roleName: "Bible Prayer",
          icon: <ManageBiblePrayerSvg />,
        },
      ];
      setlinks(links);
    }
    // eslint-disable-next-line
  }, []);

  const filteredLinks = links?.filter((item) =>
    item?.roleName?.toLowerCase()?.includes(searchTerm?.toLowerCase()),
  );

  return (
    <>
      <div className="intersight_menu">
        <div className="top_menu">
          {/*Start Logo Dropdown*/}
          <div className="brand">
            <div className="dropdown">
              <button
                className="border-0 w-100 d-flex align-items-center"
                type="button"
              >
                <span
                  className="d-flex align-items-center justify-content-center"
                  style={{ overflow: "hidden" }}
                >
                  <img src="/image/hands-pray.png" alt="" loading="lazy" />
                </span>{" "}
                Credo Admin
              </button>
            </div>
          </div>

          {/*End Logo Dropdown*/}
          {/*Start Menu*/}
          <div className={`intersight_home`}>
            <div className="menu_div">
              <ul className="menu_scrollbar">
                <li>
                  <NavLink
                    to="/dashboard"
                    className={({ isActive }) => (isActive ? "active" : "")}
                  >
                    <span>
                      <Dashboardsvg />
                    </span>
                    Dashboard
                  </NavLink>
                </li>

                <li className="without_label">Workspace</li>
                <div className="sidebar_search  mb-2">
                  <input
                    type="text"
                    placeholder="Search menu..."
                    className="form-control"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
                {filteredLinks?.map((item, i) => (
                  <SideBarLink
                    key={i}
                    href={item?.url}
                    name={item.roleName}
                    icon={item.icon}
                  />
                ))}
              </ul>
              <div className="bottom_menu">
                <p>
                  <Link
                    to="#"
                    className="d-block text-decoration-underline"
                  ></Link>
                </p>
                <div className="user_person">
                  <div className="dropdown">
                    <button
                      className="dropdown-toggle border-0 w-100 d-flex align-items-center p-0"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <span className="d-flex align-items-center justify-content-center person_icon">
                        <img src={"/image/person.svg"} alt="" loading="lazy" />
                      </span>
                      <label className="person_name">
                        {user?.name}
                        <span className="d-block">{user?.email}</span>
                      </label>
                    </button>
                    <ul className="dropdown-menu w-100">
                      {/* <li>
                        <Link className="dropdown-item" to="#">
                          Profile Info
                        </Link>
                      </li>
                      <li>
                        <Link className="dropdown-item" to="#">
                          Change Password
                        </Link>
                      </li> */}
                      <li>
                        <Link
                          className="dropdown-item"
                          to="#"
                          onClick={() => setOpen(true)}
                        >
                          Logout
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/*End Start Menu*/}
        </div>
      </div>
      <Logout open={open} handleClose={handleClose} />
    </>
  );
}
